import type { GQVmItem } from "@/admin/vm/VmsTable.tsx";
import { gqlVmToCommonVm } from "@/admin/vm/gqlToCommonVm.ts";
import { resizeDiskMutation } from "@/admin/vm/vmQuery.ts";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { BaseDiskModal } from "@/modules/compute/DiskAddOrResizeModal.tsx";
import type { VirtualMachineStorage } from "@warrenio/api-spec/spec.oats.gen";

export function AdminDiskResizeModal({ vm, disk }: { vm: GQVmItem; disk: VirtualMachineStorage }) {
    //#region Hooks
    const resizeMutation = useStandardMutation(resizeDiskMutation);
    //#endregion

    return (
        <BaseDiskModal
            vm={gqlVmToCommonVm(vm)}
            disk={disk}
            onResizeDisk={async (params) => {
                await resizeMutation.mutateAsync(params);
            }}
        />
    );
}
